import React from "react";
import { TextEditor } from "@/react/features/globalization/components/TextEditor";

export const textEdit = (row, field, onChange) => (
  <TextEditor
    value={row[field]}
    onChange={(newText) => onChange(row, field, newText)}
  />
);
